import { render, staticRenderFns } from "./PenaltiesListItem.vue?vue&type=template&id=469cb974&"
import script from "./PenaltiesListItem.vue?vue&type=script&lang=js&"
export * from "./PenaltiesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports